import React from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';

import classNames from 'classnames';

import ErrorBlock from 'components/ErrorBlock';
import {formatDateForApi} from 'utils/datetime';

import {SelectedRoomsReviewSection} from 'containers/RoomPurposes/components';
import {
  RoomPurposeDurationSection,
  SelectRoomPurposeSection
} from './components';

import {assignRoomPurpose} from 'ducks/allocations';

const formSubmit = (values, dispatch, props) => {
  const {roomPurpose, startDate, endDate} = values;
  const {selectedRoomsIds, extraActions, locationRef} = props;

  const data = {
    rooms: selectedRoomsIds,
    startDate: formatDateForApi(startDate),
    endDate: formatDateForApi(endDate),
    purpose: roomPurpose.value,
    locationRef
  };

  dispatch(assignRoomPurpose(data, extraActions));
};

class AssignRoomPurposeForm extends React.Component<any> {
  render() {
    const {error, showForm, handleSubmit} = this.props;

    return (
      <form
        onSubmit={handleSubmit}
        className={classNames('AssignRoomPurposeForm', {hidden: !showForm})}>
        {error && <ErrorBlock>{error}</ErrorBlock>}
        <SelectedRoomsReviewSection
          roomsForRoomPurposesDashboard={
            this.props.roomsForRoomPurposesDashboard
          }
          selectedRooms={this.props.selectedRooms}
          selectRoom={this.props.selectRoom}
          deselectNumberOfRooms={this.props.deselectNumberOfRooms}
          isEditable={true}
        />
        <SelectRoomPurposeSection />
        <RoomPurposeDurationSection />
      </form>
    );
  }
}

export default connect(null, null)(reduxForm({
  form: 'assignRoomPurpose',
  onSubmit: formSubmit,
  enableReinitialize: true
})(AssignRoomPurposeForm) as React.ComponentType<any>);
